require("!!C:\\svn\\10.2.0\\node_modules\\script-loader\\addScript.js")(require("!!C:\\svn\\10.2.0\\node_modules\\raw-loader\\index.js!C:\\svn\\10.2.0\\node_modules\\uglify-loader\\index.js!C:\\svn\\10.2.0\\node_modules\\tablesorter\\dist\\js\\jquery.tablesorter.combined.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/uglify-loader!./~/tablesorter/dist/js/jquery.tablesorter.combined.js
// module id = 94
// module chunks = 0